import React from 'react'
import './client-booking.css'
import { HiArrowNarrowLeft, HiOutlineBell } from "react-icons/hi";

import ProfessionalsServices from '../components/pages/booking/professionals-services'
import ClientBooking from '../components/pages/booking/client-booking-list'
import Header from '../components/shared/header'
import Calendary from '../components/pages/booking/calendary';

const screen = () => {
  return (
    
    <div className='screen-main'>
      <Header leftIcon="arrowLeft" label="Agenda" rightIcon="bell" />
      <ProfessionalsServices />
      <Calendary />
      <ClientBooking />
    </div>
    
  )
}

export default screen